/**
 * Class cho nút trên màn ma trận.
 *
 * Nút primary chỉ dùng màu thương hiệu khi đang bật. Nếu ghi đè cả lúc disabled
 * thì nền vẫn đậm màu trong khi chữ lấy màu disabled của antd, đọc không ra.
 * Ngược lại, để antd tự lo lúc disabled cũng không xong: bản override dark mode
 * của dự án làm chữ disabled gần như vô hình, nên màu tắt phải khai báo rõ ở đây.
 */
export const BRAND_BUTTON = '!bg-[#3e91ab] hover:!bg-[#357f96] !border-[#3e91ab] !text-white';

export const DISABLED_BUTTON =
    '!bg-gray-100 !border-gray-200 !text-gray-400 dark:!bg-[#1f1f1f] dark:!border-[#3a3a3a] dark:!text-[#8a8a8a]';

export function brandButton(enabled: boolean): string {
    return enabled ? BRAND_BUTTON : DISABLED_BUTTON;
}

/**
 * Nút dạng chữ. Phải khai báo màu cho cả lúc bật lẫn lúc tắt: override dark mode
 * của dự án để chữ nút text rất tối, gần như chìm hẳn vào nền.
 * Dùng `enabled:`/`disabled:` để hai trạng thái không tranh nhau độ ưu tiên.
 */
export const MUTED_TEXT_BUTTON = [
    'enabled:!text-gray-600 dark:enabled:!text-gray-200',
    'disabled:!text-gray-400 dark:disabled:!text-[#8a8a8a]',
].join(' ');
